var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loadedData && _vm.loadedData.status === "failure"
      ? _c("div", { staticClass: "alert alert-danger" }, [
          _vm._v("\n    " + _vm._s(_vm.loadedData.message) + "\n  "),
        ])
      : _vm.uploadStatus === "success"
      ? _c("div", { staticClass: "alert alert-success" }, [
          _vm._v(
            "\n    Vielen Dank! Die Dateien wurden erfolgreich übertragen!\n  "
          ),
        ])
      : _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-12" },
            [
              _c(
                "b-form-group",
                [
                  _c("h2", [_vm._v("Dateien Hochladen")]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.description))]),
                  _vm._v(" "),
                  _c("b-table", {
                    staticClass: "mt-4",
                    attrs: {
                      responsive: "",
                      fields: _vm.columns,
                      items: _vm.selectedFiles,
                      "table-class": "fmx-table",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(description)",
                        fn: function (row) {
                          return [
                            _c("b-form-input", {
                              attrs: {
                                placeholder: _vm.defaultDescription(
                                  row.item.name
                                ),
                                disabled: _vm.sending,
                              },
                              on: {
                                input: function (desc) {
                                  return _vm.updateFileDescription(
                                    row.item.name,
                                    desc
                                  )
                                },
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell(size)",
                        fn: function (row) {
                          return [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.userFriendlyFileSize(row.item.size))
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "cell(actions)",
                        fn: function (row) {
                          return [
                            _c(
                              "label",
                              {
                                staticClass: "btn btn-outline-primary",
                                class: { disabled: _vm.sending },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteFile(row.item.name)
                                  },
                                },
                              },
                              [_vm._v("X")]
                            ),
                          ]
                        },
                      },
                      {
                        key: "custom-foot",
                        fn: function () {
                          return [
                            _c(
                              "b-tr",
                              [
                                _c("b-th"),
                                _vm._v(" "),
                                _c("b-th"),
                                _vm._v(" "),
                                _c("b-th", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.userFriendlyFileSize(
                                          _vm.selectedFilesSize
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("b-th"),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "table-caption",
                        fn: function () {
                          return [
                            _vm.uploadStatus !== "waiting"
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "b-alert",
                                      {
                                        attrs: {
                                          show: _vm.uploadStatus === "failure",
                                          dismissible: "",
                                          fade: "",
                                          variant: "danger",
                                        },
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(
                                            "\n                  Tut uns leid! Beim Übertragen der Dateien ist ein technischer Fehler aufgetreten.\n                  Bitte wenden Sie sich an Ihren Kontakt bei fumiX oder den allgemeinen Support\n                  unter +49 6221 829949 / support@fumix.de !\n                "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _c("time-out-alert", {
                                      attrs: {
                                        visible:
                                          _vm.alreadySelectedFileNames.length >
                                          0,
                                      },
                                      on: {
                                        dismissed: function ($event) {
                                          _vm.alreadySelectedFileNames = ""
                                        },
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "content",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                "\n                  Die Datei "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "bold",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.alreadySelectedFileNames
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                  wurde bereits ausgewählt.\n                "
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                    }),
                                    _vm._v(" "),
                                    _c("time-out-alert", {
                                      attrs: {
                                        visible:
                                          _vm.exceedingMaxFileSizeFileNames
                                            .length > 0,
                                      },
                                      on: {
                                        dismissed: function ($event) {
                                          _vm.exceedingMaxFileSizeFileNames = ""
                                        },
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "content",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                "\n                  Die Datei "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "bold",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.exceedingMaxFileSizeFileNames
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                  kann nicht hochgeladen werden, weil sie größer als " +
                                                  _vm._s(
                                                    _vm.userFriendlyFileSize(
                                                      _vm.fileMaxSize
                                                    )
                                                  ) +
                                                  " ist.\n                "
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                    }),
                                  ],
                                  1
                                ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "label",
                      {
                        staticClass: "btn btn-outline-primary",
                        class: { disabled: _vm.sending },
                        attrs: { for: "file" },
                      },
                      [_vm._v("Datei\n            auswählen")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      ref: "file",
                      staticStyle: {
                        visibility: "hidden",
                        opacity: "0",
                        "z-index": "-1",
                        position: "absolute",
                      },
                      attrs: { type: "file", id: "file", multiple: "multiple" },
                      on: {
                        change: function ($event) {
                          return _vm.selectFiles()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.selectedFiles.length > 0
                      ? _c(
                          "label",
                          {
                            staticClass: "btn btn-outline-primary",
                            class: { disabled: _vm.sending },
                            on: {
                              click: function ($event) {
                                return _vm.sendFiles()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.sendButtonLabel) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }